import { Component, Input, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { IVariableEntry } from "libraries/model/IVariableEntry";
import { BrowserClipboardService } from '../../service/browserClipboard/browserClipboard.service';

import { faCaretRight, faCaretDown, IconDefinition } from "@fortawesome/free-solid-svg-icons";

import { Yii } from "libraries/interfaces/Yii";

@Component({
  selector: 'variables-help',
  template: `
    <button (click)="onClick($event)"
            [title]="buttonTitle"
            [class.can-deploy]="canDeploy">
      <fa-icon [icon]="deployed ? iconCaretDown : iconCaretRight" *ngIf="canDeploy"></fa-icon>
      <code *ngIf="root.code">{{root.code}}</code>
      <span>{{root.explanation}}</span>
    </button>
    <ul *ngIf="deployed">
      <li *ngFor="let child of root.children">
        <variables-help [root]="child"></variables-help>
      </li>
    </ul>
  `,
  styles: [`
    button {
      border: none;
      background: none;
    }

    ul{
      padding-left: 20px;
      margin-top: 5px;
      margin-bottom: 10px;
    }

    li{
      margin-bottom: 5px;
    }

    button{
      padding: 0;
      padding-left: 1em;
    }

    button code{
      border-radius: 5px;
      background-color: #DEDEDE;
      padding: 2px;
    }

    button.can-deploy{
      padding-left: 0;
    }
    button.can-deploy code{
      background-color: transparent;
    }
  `]
})
export class VariablesHelpComponent implements OnInit {
  @Input()
  public root: IVariableEntry;

  @Output()
  public readonly onSelectVariable: EventEmitter<null> = new EventEmitter();

  @Output()
  public readonly onSelectVariableError: EventEmitter<string> = new EventEmitter();

  public deployed: boolean = false;
  public canDeploy: boolean = false;
  public buttonTitle: string;

  public iconCaretRight: IconDefinition = faCaretRight;

  public iconCaretDown: IconDefinition = faCaretDown;

  public labels = {
    deploy: Yii.t('wui-shared-js', "Afficher ou masquer les détails"),
    copyToClipboard: Yii.t('wui-shared-js', "Copier le code dans le presse-papier"),
  };

  constructor(
    private readonly browserClipBoardService: BrowserClipboardService
  ) {}

  public ngOnInit(): void {
    this.canDeploy = this.root.children && this.root.children.length > 0;

    if (this.canDeploy) {
      this.buttonTitle = this.labels.deploy;
    } else {
      this.buttonTitle = this.labels.copyToClipboard;
    }
  }

  public onClick($event: Event): void {
    $event.preventDefault();
    if (this.canDeploy) {
      this.deployed = !this.deployed;
    } else {
      this.browserClipBoardService.copy(this.root.code)
        .then(() => this.onSelectVariable.emit())
        .catch((error: Error) => this.onSelectVariableError.emit(
          Yii.t('wui-shared-js', "Le texte n'a pas été sélectionné")
        ));
    }
  }
}
